// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__GE_wg","title":"style_title__2Nt-B","content":"style_content__1qTTX","ionSlide":"style_ionSlide__2qarP"};